//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations, mapActions } from "vuex";
import loginCopy from "../../../../data/loginPage.json"
import AlertError from "../components/AlertError.vue"
export default {
  name: "PageLogin",
  components: {
    AlertError,
  },
  data() {
    return{
      copy: loginCopy.loginPage.default,
      copyEndpoint: '/api/userdashboard/getcontent/login',
      endpoint: '/api/account/login',
      passwordFieldReveal: false,
      copyHTML: '',
      formData: {
        loginEmail: '',
        loginPassword: ''
      }
    }
  },
  computed: {
		...mapGetters(["isError", "isDisabled", "isLoading"])
  },
	methods: {
		...mapMutations(["setRegistrationPage", "setDisabled", "setResetPassword", "setResetEmail", "setError", "setLoading"]),
		...mapActions(["getAccountInfo"]),
    processLogin(data) {
      data.preventDefault()
      // console.log(this.data)
      // console.dir(data) 
      // do stuff
      const endpoint = this.endpoint;
      const loginEmail = this.formData.loginEmail;
      const loginPassword = this.formData.loginPassword;
			const afToken = this.$root.token;
      // const formVals = {
      //   email: JSON.stringify(this.$refs['login-email'].value),
      //   password: JSON.stringify(this.$refs['login-password'].value)
      // }
      // console.log(formVals)
      this.setDisabled(true)
      this.setLoading(true)
      this.getAccountInfo({endpoint, loginEmail, loginPassword, afToken})
    },
    toggleRegistration() {
      this.setRegistrationPage(true)
      this.setError(false)
      this.setDisabled(false)
    },
    togglePasswordVisibility() {
      this.passwordFieldReveal = !this.passwordFieldReveal
    },
    toggleResetPassword() {
      // console.log(this.formData.loginEmail)
      this.setResetEmail(this.formData.loginEmail)
      this.setResetPassword(true)
    }

  },
  mounted() {
    this.setLoading(true)
    this.setError(false)
    fetch(this.copyEndpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }).then((response) => response.json())
      .then((data) => {
        this.copyHTML = data.content
        setTimeout(() => {
          this.setLoading(false)
        }, 1500);
      });
  },
};
